module.exports = __webpack_public_path__ + "img/check-parceiro.f623c57b.svg";